function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.88,
    height: 9.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0622222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 4.78,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.56,
    width: 24.88,
    height: 17.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 18.42,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27.28,
    width: 24.88,
    height: 22.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 38.605000000000004,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.93,
    width: 24.88,
    height: 24.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.976
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 62.375,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.82,
    width: 24.88,
    height: 30.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 90.27499999999999,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.73,
    width: 24.88,
    height: 46.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5542857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 128.83,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.94,
    width: 24.88,
    height: 48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 175.94,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 199.94,
    width: 24.88,
    height: 51.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7644444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 225.785,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.63,
    width: 24.88,
    height: 51.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7644444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 277.525,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.41,
    width: 24.88,
    height: 52.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 329.75,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.09,
    width: 24.88,
    height: 54.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.976
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 383.13,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.18,
    width: 24.88,
    height: 55.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 438.065,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 465.95,
    width: 24.88,
    height: 56.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5542857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 494.245,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.54,
    width: 24.88,
    height: 57.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5542857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 551.2149999999999,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 579.89,
    width: 24.88,
    height: 59.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 609.875,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 639.86,
    width: 24.88,
    height: 60.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.44,
    y: 669.9300000000001,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 0,
    width: 35.75,
    height: 42.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.107142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.754999999999995,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.63,
    y: 0,
    width: 36.11,
    height: 42.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0183333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 78.685,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.74,
    y: 0,
    width: 36.58,
    height: 42.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.03,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.33,
    y: 0,
    width: 36.85,
    height: 42.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.75500000000002,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.17,
    y: 0,
    width: 38.59,
    height: 42.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.718000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.46499999999997,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.76,
    y: 0,
    width: 40.19,
    height: 42.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.02375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.855,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.95,
    y: 0,
    width: 41.68,
    height: 42.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.78999999999996,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.64,
    y: 0,
    width: 44.55,
    height: 42.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 312.91499999999996,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.19,
    y: 0,
    width: 45.78,
    height: 42.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.08,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.97,
    y: 0,
    width: 46.25,
    height: 42.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.095,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.22,
    y: 0,
    width: 51.45,
    height: 42.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8645454545454543
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.94500000000005,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.67,
    y: 0,
    width: 53.13,
    height: 42.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.501999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.235,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.8,
    y: 0,
    width: 54.39,
    height: 42.51,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.995,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.18,
    y: 0,
    width: 54.82,
    height: 42.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.501999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 613.5899999999999,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 0,
    width: 59,
    height: 42.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.072857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.5,
    y: 21.255,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 42.51,
    width: 56.96,
    height: 50.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 67.71,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 92.91,
    width: 56.96,
    height: 53.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.687999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 119.63,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 146.35,
    width: 56.96,
    height: 54.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 173.695,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 201.04,
    width: 56.96,
    height: 55.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 228.64999999999998,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 256.26,
    width: 56.96,
    height: 57.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.137142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 285.21999999999997,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 314.19,
    width: 56.96,
    height: 61.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.328888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 344.835,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 375.47,
    width: 56.96,
    height: 63.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.493333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 407.08000000000004,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 438.7,
    width: 56.96,
    height: 63.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.493333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 470.57,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 502.44,
    width: 56.96,
    height: 65.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 535.085,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 567.73,
    width: 56.96,
    height: 65.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.493333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 600.725,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.88,
    y: 633.71,
    width: 56.96,
    height: 66.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.36,
    y: 666.855,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 42.51,
    width: 55.31,
    height: 71.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.901428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.505,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.15,
    y: 42.51,
    width: 55.89,
    height: 71.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.095,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.05,
    y: 42.51,
    width: 58.63,
    height: 71.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.375714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.365,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.67,
    y: 42.51,
    width: 60.84,
    height: 71.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.691428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.09,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.52,
    y: 42.51,
    width: 67.27,
    height: 71.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.40875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.155,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.79,
    y: 42.51,
    width: 69.48,
    height: 71.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.53000000000003,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.27,
    y: 42.51,
    width: 70.38,
    height: 71.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.46,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.65,
    y: 42.51,
    width: 89.75,
    height: 71.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.525,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.4,
    y: 42.51,
    width: 90.6,
    height: 71.47,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.209999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.6999999999999,
    y: 78.245,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 113.97,
    width: 92.3,
    height: 75.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.385555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 151.70499999999998,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 189.44,
    width: 92.3,
    height: 76.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 227.54,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 265.64,
    width: 92.3,
    height: 76.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.534444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 304.04499999999996,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 342.46,
    width: 92.3,
    height: 79.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.862222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 382.34,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 422.21,
    width: 92.3,
    height: 89.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 467.07,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 511.93,
    width: 92.3,
    height: 93.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.39090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 558.485,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.85,
    y: 605.04,
    width: 92.3,
    height: 94.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128,
    y: 652.52,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.14,
    y: 113.97,
    width: 89.65,
    height: 100.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.96499999999997,
    y: 164.365,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.79,
    y: 113.97,
    width: 101.21,
    height: 100.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.19888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.39500000000004,
    y: 164.365,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 113.97,
    width: 103.02,
    height: 100.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.19888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.51,
    y: 164.365,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.02,
    y: 113.97,
    width: 110.72,
    height: 100.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.38,
    y: 164.365,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.74,
    y: 113.97,
    width: 121.26,
    height: 100.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.079
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.37,
    y: 164.365,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.14,
    y: 214.76,
    width: 114.13,
    height: 113.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.197142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.20499999999998,
    y: 271.45,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.14,
    y: 328.14,
    width: 114.13,
    height: 113.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.4825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.20499999999998,
    y: 385.105,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.14,
    y: 442.07,
    width: 114.13,
    height: 126.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.681111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.20499999999998,
    y: 505.155,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.14,
    y: 568.24,
    width: 114.13,
    height: 131.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.681111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.20499999999998,
    y: 634.12,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.28,
    y: 214.76,
    width: 90.42,
    height: 182.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.48999999999995,
    y: 306.16999999999996,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.69,
    y: 214.76,
    width: 112.07,
    height: 182.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.413999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.725,
    y: 306.16999999999996,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.76,
    y: 214.76,
    width: 209.24,
    height: 182.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.8525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.38,
    y: 306.16999999999996,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.28,
    y: 397.57,
    width: 153.66,
    height: 302.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.10999999999996,
    y: 548.785,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.93,
    y: 397.57,
    width: 258.07,
    height: 302.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.674444444444443
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.965,
    y: 548.785,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2008);
export default __webpack_public_path__ + "static/media/2008.613d50dff4e218bd67d297aee8925014.svg";
export { ForwardRef as ReactComponent };